import { useRef, useState } from 'react';
import { api } from '../api/routes';
import { messageDErreur } from '../api/useDonnees';

export type Basculer = (
  type: 'tache' | 'element',
  id: string,
  fait: boolean,
) => void;

/**
 * Cocher / decocher, partage entre Aujourd'hui et Planning.
 *
 * Un seul basculement a la fois : deux appuis rapprochés sur la meme case partiraient en
 * course (le second lirait un etat deja perime). Le verrou est une ref et non un etat,
 * pour etre lu de maniere synchrone au moment du clic.
 */
export function useCocher(
  signaler: (message: string) => void,
  rafraichir: () => void,
): { basculer: Basculer; enCours: string | null } {
  const verrou = useRef(false);
  const [enCours, setEnCours] = useState<string | null>(null);

  const basculer: Basculer = (type, id, fait) => {
    if (verrou.current) return;
    verrou.current = true;
    setEnCours(id);
    void (async () => {
      try {
        if (type === 'tache') await api.cocherTache(id, fait);
        else await api.cocherElement(id, fait);
      } catch (cause) {
        signaler(messageDErreur(cause));
      } finally {
        verrou.current = false;
        setEnCours(null);
        // Rafraichir dans TOUS les cas : apres un succes pour afficher la coche, apres
        // un echec pour remettre l'ecran en accord avec le serveur.
        rafraichir();
      }
    })();
  };

  return { basculer, enCours };
}
